import $ from 'jquery';
import enumList from 'web/utils/enumList';
import {DataTableComponent} from 'web/components/CommonComponent';

export const usePositionListModal = (baseComponent, positionList) => {
  const preparePositionListTable = () => {
    // 定義資料內容
    const dataSet = positionList.map((positionItem) => {
      return [
        positionItem.positionCode,
        positionItem.positionName,
        positionItem.description,
        positionItem.flgStatus,
        positionItem.positionId,
      ];
    });

    // 定義欄位屬性
    const columnConfig = [
      {
        title: '職位代號',
        className: 'dt-center',
        data: 0,
      },
      {title: '職位名稱', className: 'dt-center', data: 1},
      {title: '欄位說明', className: 'dt-center', data: 2},
      {
        orderable: false,
        order: null,
        title: '啟用',
        data: 3,
        className: 'dt-center',
        render: (data, type, row, meta) => {
          const enableId = 'eab-position-' + meta.row;
          const isChecked = data === enumList.flgStatus.active ? 'checked' : '';
          const enableButton = baseComponent.checkPermission(
            enumList.moduleEnums.position,
            enumList.accessModeEnums.update,
          )
            ? ''
            : 'disabled';
          return `<div class="form-check form-switch">
                                  <input class="form-check-input" type="checkbox" role="switch" id="${enableId}" ${isChecked} ${enableButton} />
                                  <label class="form-check-label" for="${enableId}"></label>
                              </div>`;
        },
      },
      {
        title: '編輯',
        className: 'dt-center',
        order: null,
        orderable: false,
        data: 4,
        render: (data, type, row, meta) => {
          const enableButton = baseComponent.checkPermission(
            enumList.moduleEnums.position,
            enumList.accessModeEnums.update,
          )
            ? ''
            : 'disabled';
          return `<button type="button" 
                           class="btn btn-sm btn-link ${enableButton} w-100 flex justify-center items-center"
                           id="edit-position-${data}">
                          <svg class="btn__icon 
                            btn__icon--sm me-1" aria-hidden="true">
                              <use href="#ico-edit"></use>
                          </svg>
                          修改
                      </button>`;
        },
      },
    ];

    // 定義排序設定
    const orderConfig = {
      // idx: 1,
      // dir: 'asc',
    };

    // 定義固定欄位設定
    const fixedColumnsConfig = {
      start: 1,
    };
    // 先清除datatable
    if ($.fn.DataTable.isDataTable('#datatable__positionList')) {
      $('#datatable__positionList').empty();
      $('#datatable__positionList').DataTable().destroy();
    }

    return DataTableComponent(
      '#datatable__positionList',
      dataSet,
      columnConfig,
      orderConfig,
      fixedColumnsConfig,
    );
  };

  return {preparePositionListTable};
};
